
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'security-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'security-bundle')

export default [
  {
    name: 'security.permissions',
    path: 'permissions',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'security.permissions.new',
        path: 'create',
        component: Form
      },
      {
        name: 'security.permissions.edit',
        path: ':id/edit',
        component: Form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/security/permissions/routes.js